import ApplicationJSONAPISerializer from 'district-ui-client/serializers/application'

export default class ImportValidationSerializer extends ApplicationJSONAPISerializer {}
